module.exports = __webpack_public_path__ + "img/burger-close.f923d7ab.svg";